import * as constants from './constants';

export function fetchPpi(id) {
  return {
    type: constants.FETCH_PPI,
    payload: id
  };
}

export function setPpiId(id) {
  return {
    type: constants.SET_PPI_ID,
    payload: id
  };
}

export function fetchPpiDone(ppi) {
  return {
    type: constants.FETCH_PPI_DONE,
    payload: ppi
  };
}

export function fetchPpiFail(error) {
  return {
    type: constants.FETCH_PPI_FAIL,
    payload: error
  };
}

export function fetchNewPPIAvilableData() {
  return {
    type: constants.FETCH_NEW_PPI_AVAILABLE
  };
}

export function fetchNewPPIAvilableDataDone(ppi) {
  return {
    type: constants.FETCH_NEW_PPI_AVAILABLE_DONE,
    payload: ppi
  };
}

export function fetchNewPPIAvilableDataFail(error) {
  return {
    type: constants.FETCH_NEW_PPI_AVAILABLE_FAIL,
    payload: error
  };
}

export function fetchPpis(payload) {
  return {
    type: constants.FETCH_PPIS,
    payload
  };
}

export function fetchPpisDone(ppis) {
  return {
    type: constants.FETCH_PPIS_DONE,
    payload: ppis
  };
}

export function fetchPpisFail(error) {
  return {
    type: constants.FETCH_PPIS_FAIL,
    payload: error
  };
}

export function fetchCopyLocalPpis(payload) {
  return {
    type: constants.FETCH_COPY_LOCAL_PPIS,
    payload
  };
}

export function fetchCopyLocalPpisDone(ppis) {
  return {
    type: constants.FETCH_COPY_LOCAL_PPIS_DONE,
    payload: ppis
  };
}

export function fetchCopyLocalPpisFail(error) {
  return {
    type: constants.FETCH_COPY_LOCAL_PPIS_FAIL,
    payload: error
  };
}

export function fetchGlobalPpis(payload) {
  return {
    type: constants.FETCH_PPIS_GLOBAL,
    payload
  };
}

export function fetchGlobalPpisDone(ppis) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_DONE,
    payload: ppis
  };
}

export function fetchGlobalPpisFail(error) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_FAIL,
    payload: error
  };
}

export function fetchUpdatePpis(payload) {
  return {
    type: constants.FETCH_PPIS_UPDATE,
    payload
  };
}

export function fetchUpdatePpisDone(ppis) {
  return {
    type: constants.FETCH_PPIS_UPDATE_DONE,
    payload: ppis
  };
}

export function fetchUpdatePpisFail(error) {
  return {
    type: constants.FETCH_PPIS_UPDATE_FAIL,
    payload: error
  };
}

export function fetchGlobalUpdatePpis(payload) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_UPDATE,
    payload
  };
}

export function fetchGlobalUpdatePpisDone(ppis) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_UPDATE_DONE,
    payload: ppis
  };
}

export function fetchGlobalUpdatePpisFail(error) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_UPDATE_FAIL,
    payload: error
  };
}

export function fetchGlobalPpisWithId(id) {
  return {
    type: constants.FETCH_GLOBAL_PPIS_WITH_ID,
    payload: id
  };
}

export function fetchGlobalPpisWithIdDone(ppis) {
  return {
    type: constants.FETCH_GLOBAL_PPIS_WITH_ID_DONE,
    payload: ppis
  };
}

export function fetchGlobalPpisWithIdFail(error) {
  return {
    type: constants.FETCH_GLOBAL_PPIS_WITH_ID_FAIL,
    payload: error
  };
}

export function createPpiVariant(id, status) {
  return {
    type: constants.CREATE_PPI_VARIANT,
    payload: { id, status }
  };
}

export function createPpiVariantDone(ppsi) {
  return {
    type: constants.CREATE_PPI_VARIANT_DONE,
    payload: ppsi
  };
}

export function emptySinglePpi(ppi) {
  return {
    type: constants.EMPTY_SINGLE_PPI,
    payload: ppi
  };
}

export function createPpiVariantFail(error) {
  return {
    type: constants.CREATE_PPI_VARIANT_FAIL,
    payload: error
  };
}

export function fetchPpisRelatedToFormulaCode(formulaCode) {
  return {
    type: constants.FETCH_PPIS,
    payload: {
      filter: { relatedToFormulaCode: formulaCode }
    }
  };
}

export function fetchPpisRelatedToPpsi(ppsiId, type) {
  return {
    type: constants.FETCH_PPIS,
    payload: {
      filter: { relatedToPPSI: ppsiId },
      type
    }
  };
}

export function createPpi(itemCode, ppi, callback) {
  return {
    type: constants.CREATE_PPI,
    payload: {
      itemCode,
      ppi,
      callback
    }
  };
}

export function createPpiDone(ppi) {
  return {
    type: constants.CREATE_PPI_DONE,
    payload: ppi
  };
}

export function createPpiFail(error) {
  return {
    type: constants.CREATE_PPI_FAIL,
    payload: error
  };
}

export function savePpi(id, ppi, callback) {
  return {
    type: constants.SAVE_PPI,
    payload: { id, ppi, callback }
  };
}

export function savePpiDone(ppi) {
  return {
    type: constants.SAVE_PPI_DONE,
    payload: ppi
  };
}

export function savePpiFail(error) {
  return {
    type: constants.SAVE_PPI_FAIL,
    payload: error
  };
}

export function publishPpi(id, data) {
  return {
    type: constants.PUBLISH_PPI,
    payload: { id, data }
  };
}

export function publishPpiDone(ppi) {
  return {
    type: constants.PUBLISH_PPI_DONE,
    payload: ppi
  };
}

export function publishPpiFail(error) {
  return {
    type: constants.PUBLISH_PPI_FAIL,
    payload: error
  };
}

export function unpublishPpi(id, data) {
  return {
    type: constants.UNPUBLISH_PPI,
    payload: { id, data }
  };
}

export function unpublishPpiDone(ppi) {
  return {
    type: constants.UNPUBLISH_PPI_DONE,
    payload: ppi
  };
}

export function unpublishPpiFail(error) {
  return {
    type: constants.UNPUBLISH_PPI_FAIL,
    payload: error
  };
}

export function markAsUptoDatePpi(id, data) {
  return {
    type: constants.MARKASUPTODATE_PPI,
    payload: { id, data }
  };
}

export function markAsUptoDatePpiDone(ppi) {
  return {
    type: constants.MARKASUPTODATE_PPI_DONE,
    payload: ppi
  };
}

export function markAsUptoDatePpiFail(error) {
  return {
    type: constants.MARKASUPTODATE_PPI_FAIL,
    payload: error
  };
}

export function createDraftPpi(id) {
  return {
    type: constants.CREATE_DRAFT_PPI,
    payload: { id }
  };
}

export function createDraftPpiDone(ppi) {
  return {
    type: constants.CREATE_DRAFT_PPI_DONE,
    payload: ppi
  };
}

export function createDraftPpiFail(error) {
  return {
    type: constants.CREATE_DRAFT_PPI_FAIL,
    payload: error
  };
}

export function importUpdatePPI(id, data) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPI,
    payload: { id }
  };
}

export function importUpdatePpiDone(ppi) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPI_DONE,
    payload: ppi
  };
}

export function importUpdatePpiFail(error) {
  return {
    type: constants.IMPORT_IFOOD_UPDATE_PPI_FAIL,
    payload: error
  };
}

// smart global PPI update - IFPPSI-582

export function importGlobalUpdatePpi(id) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPI,
    payload: { id }
  };
}

export function importGlobalUpdatePpiDone(ppi) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPI_DONE,
    payload: ppi
  };
}

export function importGlobalUpdatePpiFail(error) {
  return {
    type: constants.IMPORT_GLOBAL_UPDATE_PPI_FAIL,
    payload: error
  };
}

// PPI Discard draft actions

export function discardDraftPpi(id) {
  return {
    type: constants.DISCARD_DRAFT_PPI,
    payload: { id }
  };
}

export function discardDraftPpiDone(ppi) {
  return {
    type: constants.DISCARD_DRAFT_PPI_DONE,
    payload: ppi
  };
}

export function discardDraftPpiFail(error) {
  return {
    type: constants.DISCARD_DRAFT_PPI_FAIL,
    payload: error
  };
}

export function fetchMarketPpis(marketCode) {
  return {
    type: constants.FETCH_MARKET_PPIS,
    payload: { marketCode }
  };
}

export function fetchMarketPpisDone(ppis) {
  return {
    type: constants.FETCH_MARKET_PPIS_DONE,
    payload: ppis
  };
}

export function fetchMarketPpisFail(error) {
  return {
    type: constants.FETCH_MARKET_PPIS_FAIL,
    payload: error
  };
}

export function fetchPpisRelatedToMarketPpsi(marketCode, ppsiId) {
  return {
    type: constants.FETCH_MARKET_USED_PPIS,
    payload: {
      marketCode,
      filter: { relatedToPPSI: ppsiId }
    }
  };
}

export function fetchPpisRelatedToMarketPpsiDone(ppis) {
  return {
    type: constants.FETCH_MARKET_USED_PPIS_DONE,
    payload: ppis
  };
}

export function fetchPpisRelatedToMarketPpsiFail(error) {
  return {
    type: constants.FETCH_MARKET_USED_PPIS_FAIL,
    payload: error
  };
}

export function deletePpi(ids) {
  return {
    type: constants.DELETE_PPI,
    payload: ids
  };
}

export function deletePpiDone(ppsi) {
  return {
    type: constants.DELETE_PPI_DONE,
    payload: ppsi
  };
}

export function deletePpiFail(error) {
  return {
    type: constants.DELETE_PPI_FAIL,
    payload: error
  };
}

// Fetch non-market specific global PPI:s. Used for NIR Markets
export function fetchGlobalPpisNir(payload) {
  return {
    type: constants.FETCH_PPIS_GLOBAL_NIR,
    payload
  };
}

// Fetch global PPi IFS Market for local market
export function fetchGlobalPpiIfs(id) {
  return {
    type: constants.FETCH_GLOBAL_PPI_IFS,
    payload: id
  };
}

export function fetchGlobalPpiIfsDone(ppis) {
  return {
    type: constants.FETCH_GLOBAL_PPI_IFS_DONE,
    payload: ppis
  };
}

export function fetchGlobalPpiIfsFail(error) {
  return {
    type: constants.FETCH_GLOBAL_PPI_IFS_FAIL,
    payload: error
  };
}

//create global ppi variant dialog
export function openGlobalPpiDialog(payload) {
  return {
    type: constants.GLOBAL_VARIANT_DIALOG,
    payload
  };
}

//Fetch global PPi IFS Market for local market
export function fetchGlobalPpiVariant(id) {
  return {
    type: constants.FETCH_GLOBAL_PPI_VARIANT,
    payload: id
  };
}

export function fetchGlobalPpiVariantDone(ppis) {
  return {
    type: constants.FETCH_GLOBAL_PPI_VARIANT_DONE,
    payload: ppis
  };
}

export function fetchGlobalPpiVariantFail(error) {
  return {
    type: constants.FETCH_GLOBAL_PPI_VARIANT_FAIL,
    payload: error
  };
}
